export function formatDisplayValue(value: string | undefined | null): string {
  if (typeof value !== 'string' || !value) {
    return 'N/A';
  }

  // Check if this looks like a grade range pattern (e.g., "k-8", "3-5", "math-k-8")
  const gradeRangePattern = /([a-z]+-)?(k|[0-9]+)-([0-9]+)$/i;
  if (gradeRangePattern.test(value)) {
    // For grade ranges, preserve the grade portion with hyphens but format the prefix
    const match = value.match(/^(.+-)?(k|[0-9]+)-([0-9]+)$/i);
    if (match) {
      const [, prefix = '', startGrade, endGrade] = match;
      const formattedPrefix = prefix
        ? prefix
            .slice(0, -1)
            .split('-')
            .map((word) =>
              word.toLowerCase() === 'ela'
                ? 'ELA'
                : word.charAt(0).toUpperCase() + word.slice(1),
            )
            .join(' ') + ' '
        : '';
      return `${formattedPrefix}${startGrade.toUpperCase()}-${endGrade}`;
    }
  }

  // For non-grade-range values, use the original formatting (spaces)
  return value
    .split('-')
    .map((word) =>
      word.toLowerCase() === 'ela'
        ? 'ELA'
        : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join(' ');
}

export function formatDisplayFormat(value: string | undefined | null): string {
  if (typeof value !== 'string' || !value) {
    return 'N/A';
  }

  // Normalize the value for comparison (remove hyphens, lowercase)
  const normalized = value.toLowerCase().replace(/-/g, ' ');

  // Format-specific mappings
  const formatMap: Record<string, string> = {
    'core comprehensive': 'Core: Comprehensive',
    'core no foundational skills': 'Core: No Foundational Skills',
    'supplemental foundational skills': 'Supplemental: Foundational Skills Only',
    'supplemental foundational skills only': 'Supplemental: Foundational Skills Only',
    'core course': 'Core: Course',
  };

  return formatMap[normalized] || formatDisplayValue(value);
} 